import clsx from "clsx";
import { forwardRef } from "react";

import type { CardProps } from "./card.types";

export const Card = forwardRef<HTMLDivElement, CardProps>((props, ref) => {
  const {
    children,
    className,
    dropShadow = true,
    subTitle,
    title,
    upperSection,
    ...rest
  } = props;

  return (
    <div
      ref={ref}
      className={clsx(
        "rounded-lg p-[42px] bg-brand-white",
        dropShadow && "shadow-[0_12px_26px_0_rgba(47,125,200,0.14)]",
        className
      )}
      {...rest}
    >
      {upperSection && <div className="mb-3">{upperSection}</div>}
      {title && typeof title === "string" && (
        <div className="mb-2">
          <div className="text-h-xl text-humble-blue-500">{title}</div>
          {subTitle && (
            <p className="mt-3 text-fjord-grey-400 text-p-s">{subTitle}</p>
          )}
        </div>
      )}
      {children}
    </div>
  );
});

Card.displayName = "Card";
